import { render, staticRenderFns } from "./token-invalid.vue?vue&type=template&id=60c985d8&"
import script from "./token-invalid.vue?vue&type=script&lang=js&"
export * from "./token-invalid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports